import { ConfigModuleCategory } from 'library/ts/model/enums/config/ConfigModuleCategory';
import { ImportRole } from 'library/ts/model/enums/config/ImportRole';
import { ImportType } from 'library/ts/model/enums/config/ImportType';
import { Protocol } from 'library/ts/model/enums/net/Protocol';
import { Domain } from 'library/ts/model/enums/web/Domain';
import { SubDomain } from 'library/ts/model/enums/web/SubDomain';
import { Namespace } from 'library/ts/namespaces/Namespace';
const projectInfo = window?.PlayerServicesProjectInfo;
const urlPrefix = `${Protocol.HTTPS}://${SubDomain.PLAYER_SERVICES}.${Domain.CBSCOM}/`;
export const TagConfigPluginSample = {
    category: ConfigModuleCategory.PLUGIN,
    enabled: false,
    params: {
        preload: true,
        owner: 'PlayerManager',
        import: {
            app: {
                enabled: true,
                type: ImportType.SCRIPT,
                role: ImportRole.EXECUTABLE,
                namespace: Namespace.TAG_PLUGIN_SAMPLE,
                url: {
                    regular: `${urlPrefix}${projectInfo?.app_output_dir?.tag_plugin_sample?.token}/${projectInfo?.app_output_file?.tag_plugin_sample?.js?.min?.token}`
                },
                order: 1
            }
        },
        config: {}
    }
};
